import { ReactNode } from 'react';

import { ResourceRegionType, type HubsViewMode } from '#shared';

import { surgeonLabelsMap } from '../helpers';
import { DeviceSpecialistGroupCard, SurgeonGroupCard } from '../HubStatusCard';
import { DrawerViewType } from '../ResourceDrawer';

import type { HubReportStatus } from '#entities';

export const renderRegionCards = (
  region: ResourceRegionType,
  surgeons: HubReportStatus['staffInfo'][] = [],
  items: HubReportStatus[] = [],
  onClickHub?: (id: string, type: DrawerViewType) => void,
  onClickSurgeon?: (index: number) => void,
  hubsViewMode?: HubsViewMode,
): ReactNode[] => {
  const labels = surgeonLabelsMap[region] ?? [];

  const topSurgeons = surgeons[0] ?? [];
  const bottomSurgeons = surgeons[1] ?? [];

  const handleHubSelected = (id: string) => {
    onClickHub?.(id, DrawerViewType.Hub);
  };
  const handleSurgeonSelected = (index: number) => {
    onClickSurgeon?.(index);
  };

  const top = (
    <SurgeonGroupCard
      key={`${region}-surgeon-top`}
      surgeons={topSurgeons}
      region={region}
      label={labels[0]}
      onClick={() => handleSurgeonSelected(0)}
      hubsViewMode={hubsViewMode}
    />
  );

  const bottom =
    bottomSurgeons.length > 0 ? (
      <SurgeonGroupCard
        key={`${region}-surgeon-bottom`}
        surgeons={bottomSurgeons}
        region={region}
        label={labels[1]}
        onClick={() => handleSurgeonSelected(1)}
        hubsViewMode={hubsViewMode}
      />
    ) : null;

  const hubCards = items.map(hub => (
    <DeviceSpecialistGroupCard
      key={hub.id}
      {...hub}
      region={region}
      onClick={() => handleHubSelected(hub.id)}
      hubsViewMode={hubsViewMode}
    />
  ));

  if (
    region === ResourceRegionType.East ||
    region === ResourceRegionType.West
  ) {
    return [top, ...hubCards, bottom].filter(Boolean);
  }

  return [top, ...hubCards];
};
